export default __webpack_public_path__ + "img/logo.23337c81e899889c0c4f4abf875ce9a1.png";